<template>
    <div>
        <question
            :key="k"
            style="margin-bottom: 1rem"
            :state="checkState(question)"
            v-for="(question, k) in questions"
            :score.sync="question.score.$model"
            :degrees="question.$model.degrees"
            :is-required="question.$model.is_required"
            :scaleFormat="question.scale_format.$model"
            :degreeId.sync="question.degree_id.$model"
            :isNullable="question.$model.is_nullable"
            :hasScore="questionHasSomeAnswer(question)"
            :question="question.$model.key_behavior_title"
            :notAbleToAnswer.sync="question.not_able_to_answer.$model"
            :disabled="!isEditing || isLoading(question.$model.id, 'creating')"
            @change="onAnswerQuestion(question.$model, $event)"
        >
            <template slot="loaders">
                <div v-if="showSavingNotification" class="text-primary mt-2">
                    <transition name="fade-autosave">
                        <div v-if="isLoading(question.$model.id, 'creating')">
                            <i class="fa fa-spinner fa-spin px-2" />
                            <span class="text-primary">
                                {{ $t('values.savingAnswer') }}
                            </span>
                        </div>

                        <div v-if="isLoading(question.$model.id, 'updating')">
                            <i class="fa fa-spinner fa-spin px-2" />
                            <span>
                                {{ $t('values.updatingAnswer') }}
                            </span>
                        </div>

                        <div
                            v-if="isLoading(question.$model.id, 'afterUpdate')"
                            class="ml-2"
                        >
                            <i class="fas fa-save fa-lg pr-2" />
                            <span>
                                {{ $t('values.changesSaved') }}
                            </span>
                        </div>
                    </transition>
                </div>
            </template>
        </question>
    </div>
</template>

<script>
import { Question } from '@/views/values/components'
import { createScore, updateScore } from '@/views/values/api'

export default {
    components: {
        Question,
    },
    props: {
        questions: {
            type: Array,
            required: true,
        },
        evaluationId: {
            type: Number,
            required: true,
        },
        valueId: {
            type: Number,
            required: true,
        },
        isEditing: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loaders: {},
        }
    },
    methods: {
        questionHasSomeAnswer(question) {
            return (
                question.score_id.$model !== null ||
                this.isLoading(question.$model.id, 'creating')
            )
        },
        checkState(value) {
            if (!this.isEditing) {
                return null
            }

            return value.$dirty ? !value.$invalid : null
        },
        isLoading(key, operation) {
            return this.loaders[key] ? this.loaders[key][operation] : false
        },
        async onAnswerQuestion(question, newScore) {
            this.setLoader({
                key: question.id,
                creating: question.score_id === null,
                updating: question.score_id !== null,
            })

            const payload = this.getAnswerPayload(question, newScore)

            if (question.score_id === null) {
                await createScore(payload).then(score => {
                    question.score_id = score.id
                })
            } else {
                await updateScore(question.score_id, payload)
            }

            this.setLoader({
                key: question.id,
                afterUpdate: true,
            })

            setTimeout(() => {
                this.setLoader({
                    key: question.id,
                })
            }, 3000)
        },
        setLoader({
            key,
            creating = false,
            updating = false,
            afterUpdate = false,
        }) {
            this.$set(this.loaders, key, {
                creating,
                updating,
                afterUpdate,
            })
        },
        getAnswerPayload(question, newScore) {
            return {
                degree_score: newScore,
                question_id: question.id,
                evaluation_id: this.evaluationId,
            }
        },
        showSavingNotification() {
            return Object.keys(this.loaders).length > 0
        },
    },
}
</script>
